// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.au-spotlight {
  position: fixed;
  inset: 0;
  z-index: 1400;
}

.au-spotlight__backdrop {
  position: absolute;
  inset: 0;
  border: 0;
  background: rgba(0, 0, 0, 0.55);
  backdrop-filter: blur(8px);
  -webkit-backdrop-filter: blur(8px);
}

.au-spotlight__panel {
  position: relative;
  top: 15vh;
  width: min(560px, calc(100vw - 32px));
  max-height: 480px;
  margin: 0 auto;
  border: var(--admin-border-default);
  border-radius: var(--admin-radius-lg);
  background: #0d0d0d;
  overflow: hidden;
}

.au-spotlight__search {
  padding: var(--admin-s4);
  border-bottom: 1px solid rgba(255, 255, 255, 0.06);
}

.au-spotlight__results {
  max-height: calc(480px - 64px);
  overflow-y: auto;
}

.au-spotlight__result {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--admin-s4);
  width: 100%;
  padding: var(--admin-s4);
  border: 0;
  border-left: 2px solid transparent;
  border-bottom: 1px solid rgba(255, 255, 255, 0.04);
  background: transparent;
  color: inherit;
  text-align: left;
  cursor: pointer;
}

.au-spotlight__result:hover,
.au-spotlight__result.is-active {
  border-left-color: var(--admin-accent);
  background: var(--admin-bg-active);
}

.au-spotlight__result-main,
.au-spotlight__result-meta {
  display: grid;
  gap: 4px;
}

.au-spotlight__result-label {
  color: var(--admin-text-primary);
  font-size: var(--admin-text-base);
  font-weight: var(--admin-font-weight-semibold);
}

.au-spotlight__result-description {
  color: var(--admin-text-secondary);
  font-size: var(--admin-text-sm);
  line-height: 1.45;
}

.au-spotlight__result-meta {
  justify-items: end;
  flex: 0 0 auto;
}

.au-spotlight__domain-pill {
  padding: 2px 6px;
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: var(--admin-radius-sm);
  color: var(--admin-text-secondary);
  font-size: var(--admin-text-micro);
  font-weight: var(--admin-font-weight-bold);
  letter-spacing: 0.08em;
  text-transform: uppercase;
}

.au-spotlight__section {
  color: var(--admin-text-muted);
  font-size: var(--admin-text-xs);
  text-transform: capitalize;
}

.au-spotlight__empty {
  display: grid;
  justify-items: center;
  gap: var(--admin-s4);
  padding: var(--admin-s8) var(--admin-s5);
}

.au-spotlight__empty-title {
  margin: 0;
  color: var(--admin-text-secondary);
  font-size: var(--admin-text-sm);
}

@media (max-width: 720px) {
  .au-spotlight__panel {
    top: 10vh;
  }

  .au-spotlight__result {
    align-items: start;
    flex-direction: column;
  }

  .au-spotlight__result-meta {
    justify-items: start;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Admin/ui/AdminSpotlight.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,QAAQ;EACR,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,+BAA+B;EAC/B,0BAA0B;EAC1B,kCAAkC;AACpC;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,qCAAqC;EACrC,iBAAiB;EACjB,cAAc;EACd,mCAAmC;EACnC,qCAAqC;EACrC,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,wBAAwB;EACxB,kDAAkD;AACpD;;AAEA;EACE,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,oBAAoB;EACpB,WAAW;EACX,wBAAwB;EACxB,SAAS;EACT,kCAAkC;EAClC,kDAAkD;EAClD,uBAAuB;EACvB,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA;;EAEE,sCAAsC;EACtC,kCAAkC;AACpC;;AAEA;;EAEE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,gCAAgC;EAChC,iCAAiC;EACjC,8CAA8C;AAChD;;AAEA;EACE,kCAAkC;EAClC,+BAA+B;EAC/B,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,2CAA2C;EAC3C,qCAAqC;EACrC,kCAAkC;EAClC,kCAAkC;EAClC,0CAA0C;EAC1C,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,8BAA8B;EAC9B,+BAA+B;EAC/B,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,oBAAoB;EACpB,wCAAwC;AAC1C;;AAEA;EACE,SAAS;EACT,kCAAkC;EAClC,+BAA+B;AACjC;;AAEA;EACE;IACE,SAAS;EACX;;EAEA;IACE,kBAAkB;IAClB,sBAAsB;EACxB;;EAEA;IACE,oBAAoB;EACtB;AACF","sourcesContent":[".au-spotlight {\n  position: fixed;\n  inset: 0;\n  z-index: 1400;\n}\n\n.au-spotlight__backdrop {\n  position: absolute;\n  inset: 0;\n  border: 0;\n  background: rgba(0, 0, 0, 0.55);\n  backdrop-filter: blur(8px);\n  -webkit-backdrop-filter: blur(8px);\n}\n\n.au-spotlight__panel {\n  position: relative;\n  top: 15vh;\n  width: min(560px, calc(100vw - 32px));\n  max-height: 480px;\n  margin: 0 auto;\n  border: var(--admin-border-default);\n  border-radius: var(--admin-radius-lg);\n  background: #0d0d0d;\n  overflow: hidden;\n}\n\n.au-spotlight__search {\n  padding: var(--admin-s4);\n  border-bottom: 1px solid rgba(255, 255, 255, 0.06);\n}\n\n.au-spotlight__results {\n  max-height: calc(480px - 64px);\n  overflow-y: auto;\n}\n\n.au-spotlight__result {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: var(--admin-s4);\n  width: 100%;\n  padding: var(--admin-s4);\n  border: 0;\n  border-left: 2px solid transparent;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.04);\n  background: transparent;\n  color: inherit;\n  text-align: left;\n  cursor: pointer;\n}\n\n.au-spotlight__result:hover,\n.au-spotlight__result.is-active {\n  border-left-color: var(--admin-accent);\n  background: var(--admin-bg-active);\n}\n\n.au-spotlight__result-main,\n.au-spotlight__result-meta {\n  display: grid;\n  gap: 4px;\n}\n\n.au-spotlight__result-label {\n  color: var(--admin-text-primary);\n  font-size: var(--admin-text-base);\n  font-weight: var(--admin-font-weight-semibold);\n}\n\n.au-spotlight__result-description {\n  color: var(--admin-text-secondary);\n  font-size: var(--admin-text-sm);\n  line-height: 1.45;\n}\n\n.au-spotlight__result-meta {\n  justify-items: end;\n  flex: 0 0 auto;\n}\n\n.au-spotlight__domain-pill {\n  padding: 2px 6px;\n  border: 1px solid rgba(255, 255, 255, 0.08);\n  border-radius: var(--admin-radius-sm);\n  color: var(--admin-text-secondary);\n  font-size: var(--admin-text-micro);\n  font-weight: var(--admin-font-weight-bold);\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n}\n\n.au-spotlight__section {\n  color: var(--admin-text-muted);\n  font-size: var(--admin-text-xs);\n  text-transform: capitalize;\n}\n\n.au-spotlight__empty {\n  display: grid;\n  justify-items: center;\n  gap: var(--admin-s4);\n  padding: var(--admin-s8) var(--admin-s5);\n}\n\n.au-spotlight__empty-title {\n  margin: 0;\n  color: var(--admin-text-secondary);\n  font-size: var(--admin-text-sm);\n}\n\n@media (max-width: 720px) {\n  .au-spotlight__panel {\n    top: 10vh;\n  }\n\n  .au-spotlight__result {\n    align-items: start;\n    flex-direction: column;\n  }\n\n  .au-spotlight__result-meta {\n    justify-items: start;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
